import React, { useState } from 'react'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import { useQuery, useMutation } from '@apollo/react-hooks'
import FileDownload from 'js-file-download'
import {
  Button, Modal, DatePicker, Select, message,
} from 'antd'
import {
  H2, Div, H3, P, Loading,
} from 'konsys-ui'
import { GET_FLEETS } from '../../constants/graphql/query'
import { Container } from './styled'
import { getAccessToken, getURL } from '../../utils/local-data-service'
import { ImportModal } from './components'
import { IMPORT_FIXED_COST } from '../../constants/graphql/mutation'
import { ENUM } from '../../constants/company-name'

const Center = ({ children }) => (
  <Div flexDirection='column' display='flex' justifyContent='center' alignItems='center' width='100%' margin='80px 0 0 0'>{children}</Div>
)

const FleetReportModal = ({
  fleetReportModal, setFleetReportModal, isLoading, setIsLoading,
}) => {
  const [date, setDate] = useState()
  const [fleet, setFleet] = useState('all')
  const {
    loading, data, error, refetch,
  } = useQuery(GET_FLEETS)
  if (loading || _.isEmpty(data)) return <Loading />
  return (
    <Modal
      title="พิมพ์รายงานประจำเดือน ราย Fleet"
      visible={fleetReportModal}
      destroyOnClose={true}
      onCancel={() => {
        setFleetReportModal(false)
        setDate()
        setFleet('all')
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/superuser/report/fleet?selectedDate=${moment(date).startOf('month').format('YYYY-MM-DD')}&fleetId=${fleet}`,
        }).then((resp) => {
          FileDownload(resp.data, `รายงานประจำเดือน  ${moment(date).format('MMMM YYYY')} ของfleet ${fleet === 'all' ? 'ทั้งหมด' : fleet}.xlsx`)
          setFleetReportModal(false)
          setDate()
          setFleet('')
          setIsLoading(false)
        })
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(date),
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
        <P margin='16px 0'>เลือกเดือน</P>
        <DatePicker.MonthPicker
          placeholder='เลือกเดือน'
          style={{ width: '334px' }}
          format='DD/MM/YYYY'
          onChange={(e) => {
            setDate(e)
          }}
        />
      </Div>
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
        <P margin='16px 0'>เลือก Fleet</P>
        <Select
          style={{ width: 334 }}
          defaultValue="ทั้งหมด"
          onSelect={(e) => {
            setFleet(e)
          }}
        >
          <Select.Option key='all' value='all'>ทั้งหมด</Select.Option>
          {
            data.FleetList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.name}</Select.Option>)
          }
        </Select>
      </Div>
    </Modal>
  )
}

export default () => {
  const [showModal, setShowModal] = useState(false)
  const [date, setDate] = useState(moment())
  const [isLoading, setIsLoading] = useState(false)
  const [incomeModal, setIncomeModal] = useState(false)
  const [fleetReportModal, setFleetReportModal] = useState(false)
  const [file, setFile] = useState([])
  const [arr, setArr] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [company, setCompany] = useState(ENUM.PADOONGRICH)
  const [doImport, importFixedCost] = useMutation(IMPORT_FIXED_COST)

  const download = (selecteddate) => {
    setIsLoading(true)
    const option = {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
      url: `${getURL().FILE_SERVER}/download/superuser/report/?selectedDate=${selecteddate.format('YYYY-MM')}`,
    }
    axios.all([axios(option)])
      .then(axios.spread((resp) => {
        FileDownload(resp.data, `รายงานประจำเดือน ${selecteddate.format('MM/YYYY')}.xlsx`)
        setIsLoading(false)
        setShowModal(false)
      }))
  }

  const downloadIncome = (selecteddate) => {
    setIsLoading(true)
    const option = {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
      url: `${getURL().FILE_SERVER}/download/superuser/customerSummaryReport?selectedDate=${selecteddate.format('YYYY-MM')}`,
    }
    axios.all([axios(option)])
      .then(axios.spread((resp) => {
        FileDownload(resp.data, `พิมพ์รายงานรายได้ ${selecteddate.format('MM/YYYY')}.xlsx`)
        setIsLoading(false)
        setIncomeModal(false)
      }))
  }

  return (
    <Container>
      <Center>
        <H2 textAlign='center'>ระบบบริหารทรัพยากรขององค์กร</H2>
        <H3 textAlign='center'>บริษัท ผดุงฤทธิ์ ขนส่ง จำกัด</H3>
        {
          _.includes(['SuperAdmin', 'Admin'], window.role)
          && [
            <Div key='i' flexDirection='row' display='flex' justifyContent='center' alignItems='center' width='100%' margin='40px 0 0 0'>
              <Button key='button1' style={{ marginRight: 80 }} type='primary' shape='round' icon='file-done' size='large' onClick={() => setShowModal(true)}>พิมพ์รายงานประจำเดือน</Button>
              <Button key='button2' style={{ marginRight: 80 }} type='primary' shape='round' icon='file-done' size='large' onClick={() => setFleetReportModal(true)}>พิมพ์รายงานประจำเดือน ราย Fleet</Button>
              <Button key='button3' style={{ marginRight: 80 }} type='primary' shape='round' icon='file-done' size='large' onClick={() => setIncomeModal(true)}>พิมพ์รายงานรายได้</Button>
              <Button key='button3' style={{ marginRight: 80 }} type='primary' shape='round' icon='file-done' size='large' onClick={() => setModalVisible(true)}>นำเข้าข้อมูลต้นทุนคงที่</Button>
            </Div>,
            <Modal
              key='modal'
              title='พิมพ์รายงานประจำเดือน'
              visible={showModal}
              onOk={() => {
                download(date)
              }}
              onCancel={() => setShowModal(false)}
              okText='พิมพ์รายงาน'
              okButtonProps={{
                disabled: _.isUndefined(date),
                loading: isLoading,
              }}
              cancelButtonProps={{
                disabled: isLoading,
              }}
            >
              <Div display='flex' width='100%' justifyContent='center'>
                <DatePicker.MonthPicker size='large' placeholder='เลือกเดือน / ปี' defaultValue={moment()} onChange={e => setDate(e)} />
              </Div>
            </Modal>,
            <Modal
              key='modal2'
              title='พิมพ์รายงานรายได้'
              visible={incomeModal}
              onOk={() => {
                downloadIncome(date)
              }}
              onCancel={() => setIncomeModal(false)}
              okText='พิมพ์รายงาน'
              okButtonProps={{
                disabled: _.isUndefined(date),
                loading: isLoading,
              }}
              cancelButtonProps={{
                disabled: isLoading,
              }}
            >
              <Div display='flex' width='100%' justifyContent='center'>
                <DatePicker.MonthPicker size='large' placeholder='เลือกเดือน / ปี' defaultValue={moment()} onChange={e => setDate(e)} />
              </Div>
            </Modal>,
            <ImportModal key='modal3' attr={{
              setFile, file, company, setCompany, arr, setArr,
              }} modalAttr={{ modalVisible, setModalVisible }}
              handleImport={{
                doImport: (isConfirm, convertedFile) => {
                  doImport({ variables: { data: convertedFile || arr, company, isConfirm } }).then((resp) => {
                    if (isConfirm) {
                      if (resp.data?.ImportFixedCostExcel?.success) {
                        message.success(resp.data?.ImportFixedCostExcel?.message)
                        setModalVisible(false)
                      } else message.error(resp.data?.ImportFixedCostExcel?.message)
                    } else if (!resp.data?.ImportFixedCostExcel?.success) {
                      setModalVisible(false)
                      message.error(resp.data?.ImportFixedCostExcel?.message)
                      setFile([])
                    }
                  })
                },
                ...importFixedCost,
              }}
            />,
            <FleetReportModal
              key='fleet'
              fleetReportModal={fleetReportModal}
              setFleetReportModal={setFleetReportModal}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />,
          ]
        }
      </Center>
    </Container>
  )
}
